// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Model
import PayPlanAssignment from "@/PayPlans/models/Assignments/Group";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/payplans/Group.svg";

export default function Individual() {
	return (
		<PageLayer
			title="Group Pay Plan Assignments"
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon
						viewBox="-2 -2 24 24"
						className="text-[var(--medium-pink-color)] [&>path]:fill-[var(--medium-pink-color)] !text-[30px]"
						component={Icon}
					/>
				</Stack>
			}
		>
			<PayPlanAssignment />
		</PageLayer>
	);
}
